import CallInterface from '@components/crm/calling';
import SpinnerPage from '@components/icons/SpinnerPage';
import DefaultLayout from '@components/layout/layout/DefaultLayout';
import { useAuthenticatedContextProvider } from '@contexts/AuthenticatedContextProvider';
import { useEffect } from 'react';

const AgentHome = () => {
  // Resources
  const { loading, authenticatedUser } = useAuthenticatedContextProvider();

  // Side Effects
  useEffect(() => {
    document.title = 'Aircall';
  }, []);

  // Loading State
  if (!authenticatedUser || loading) return <SpinnerPage />;

  return (
    <DefaultLayout>
      <CallInterface />
    </DefaultLayout>
  );
};
export default AgentHome;
